import Vue from 'vue'
import App from './App.vue'
import router from './router/router'
import store from './store'
import moment from 'moment'
import Library from '@bsb/library'
import '@bsb/library/dist/css/uikit.min.css'
import '@/scss/main.scss'

import UIKit from '@bsb/library/dist/js/uikit.min'
import UIKitIcons from '@bsb/library/dist/js/uikit-icons.min'
import Progress from 'vue-multiple-progress'
import Vuelidate from 'vuelidate'
import VueMask from 'v-mask'
import VModal from 'vue-js-modal'
import VueRecaptcha from 'vue-recaptcha'
import Spinner from '@/components/spinner/b-spinner'

import Components from '@/components/index'
import WrapperContent from './views/layout/desktop/content/WrapperContent'

Vue.component('WrapperContent', WrapperContent)
Vue.component('VueRecaptcha', VueRecaptcha)
Vue.component('Spinner', Spinner)

Vue.config.productionTip = false

UIKit.use(UIKitIcons)
Vue.prototype.$UIKit = UIKit
Vue.prototype.$moment = moment

Vue.use(VModal)

Components.install(Vue)

Vue.use(Library)
Vue.use(Progress)
Vue.use(Vuelidate)
Vue.use(VueMask)

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
